<template>
  <b-form @submit.prevent="submit">
    <b-tabs small card>
      <b-tab title="General">
        <b-form-group label="Nombre">
          <b-form-input v-model="plantillaContenido.nombre" required type="text" placeholder="Nombre de la plantilla" />
        </b-form-group>

        <b-form-group label="Paises">
          <combo-multiple
            :value="paisesIdCombo"
            :options="opcionesPaises"
            url="paises/autocompletar"
            @input="selectPaises"
          />
        </b-form-group>
      </b-tab>
      <b-tab title="Presentación">
        <b-form-group label="Carta de presentación">
          <wysiwyg id="editorTexto" placeholder="Escriba aquí" v-model="plantillaContenido.texto" />
        </b-form-group>
      </b-tab>
      <b-tab title="Necesidades">
        <b-form-group label="Necesidades">
          <wysiwyg id="editorNecesidades" placeholder="Escriba aquí" v-model="plantillaContenido.necesidades" />
        </b-form-group>
      </b-tab>
      <b-tab title="Resumen ejecutivo">
        <b-form-group label="Resumen Ejecutivo">
          <wysiwyg
            id="editorResumenEjecutivo"
            v-model="plantillaContenido.resumenEjecutivo"
            placeholder="Escriba aquí"
          />
        </b-form-group>
      </b-tab>

      <b-tab title="Aclaraciones">
        <b-form-group label="Aclaraciones">
          <wysiwyg id="editorAclaraciones" v-model="plantillaContenido.aclaraciones" placeholder="Escriba aquí" />
        </b-form-group>
      </b-tab>

      <b-tab title="Logos">
        <b-form-group label="Logos de Clientes">
          <wysiwyg id="editorLogosClientes" v-model="plantillaContenido.logosClientes" />
        </b-form-group>
      </b-tab>

      <b-tab title="Anexo">
        <b-form-group label="Anexo">
          <wysiwyg id="editorAnexo" placeholder="Escriba aquí" v-model="plantillaContenido.anexo" />
        </b-form-group>
      </b-tab>

      <b-tab title="Más (Extendido)">
        <b-form-group label="Beneficios">
          <wysiwyg v-model="plantillaContenido.beneficios" placeholder="Escriba aquí" />
        </b-form-group>
        <b-form-group label="Usuarios">
          <wysiwyg v-model="plantillaContenido.usuarios" placeholder="Escriba aquí" />
        </b-form-group>
        <b-form-group label="Plan de soporte">
          <wysiwyg v-model="plantillaContenido.planDeSoporte" placeholder="Escriba aquí" />
        </b-form-group>
        <b-form-group label="Requisitos mínimos">
          <wysiwyg v-model="plantillaContenido.requisitosMinimos" placeholder="Escriba aquí" />
        </b-form-group>
      </b-tab>
    </b-tabs>

    <botonera-edicion url-cancelar="/plantillasContenido" />
  </b-form>
</template>
<script>
import * as paisesApi from "@/services/paises.js";
export default {
  props: {
    plantillaContenido: Object,
    paisesId: Array,
    opcionesPaises: Array,
  },
  data() {
    return {
      listaPaises: [],
      paisesIdCombo: this.paisesId ? this.paisesId : [],
      paisesSeleccionados: [],
    };
  },
  computed: {},
  watch: {
    "$route.params": {
      handler: function () {
        this.listarPaises();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listarPaises() {
      return paisesApi.listar(this.$route.query).then((resultado) => {
        this.listaPaises = resultado.paises;
      });
    },
    selectPaises(paisesCombo) {
      this.paisesSeleccionados = [];
      var p = {};
      for (p in paisesCombo) {
        this.paisesSeleccionados.push({
          plantillaContenidoId: this.plantillaContenido.id,
          paisId: paisesCombo[p],
        });
      }
    },
    submit() {
      this.$emit("submit", this.paisesSeleccionados);
    },
  },
};
</script>
